(function facetFilter() {
  'use strict';
  var HTTPService = require('../services/http-service');
  var $modal = $('#modal-navigation-filters');
  var CheckboxModal = require('./checkbox-modal');
  var FilterList = require('./filter-list');

  function _interceptFilterLink(e) {
    e && e.preventDefault();

    var target = $(this).attr('href').replace('?', '&');
    var selectedFilter = $(this).data('selected-filter');

    _openLoad();

    target += '&selected_filter=' + selectedFilter;

    HTTPService.get('/api/htmls/filter-ajax?uri=' + target)
      .then(HTTPService.handleClientError)
      .then(function (data) {
        if (data) {
          $modal.html(data);
          CheckboxModal.init();
          FilterList.getCurrentFacets($(data).find('.modal-navigation-marca'));
        }
      });
  }

  function _openLoad() {
    var load = $modal.find('.feedback-fixed');
    load.addClass('is-open');
  }

  $modal
    .on('tap click', '.filter-item-link', _interceptFilterLink)
    .on('tap click', '.js-apply-filters', _openLoad)
    .on('tap click', '.js-clear-filters', _openLoad);
})();
